import React, { useContext, useState } from "react";
import AppContainer from "../../Components/Structure/AppContainer";
import ajaxDailyOutput from "../../util/remote/ajaxDailyOutput";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Toaster, toast } from "react-hot-toast";
import TeamContext from "../../Context/TeamContext";
import Select from "react-select";
function CreateDailyOutput() {
  const { teamList } = useContext(TeamContext);

  const { id } = useParams();
  const [teamId, setTeamID] = useState("");
  const [site, setSite] = useState("");
  const [achievedWork, setAchievedWork] = useState("");
  const navigation = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleAddOutput = async (e) => {
    e.preventDefault();

    if (teamId > 0 && achievedWork.length > 0 && site.length > 0) {
      setLoading(true);

      const server_response = await ajaxDailyOutput.createOutput(
        id,
        teamId,
        achievedWork,
        site
      );
      if (server_response.status === "OK") {
        toast.success(server_response.message);
        setTimeout(() => {
          setLoading(false);
          navigation(-1);
        }, 1500);
      } else {
        toast.error(server_response.message);
      }
    } else {
      toast.error("Complete all fields and try again");
    }
  };

  return (
    <AppContainer title="Record Output">
      <Toaster />
      <Link
        onClick={() => navigation(-1)}
        className="btn btn-primary btn-sm mb-2"
      >
        Back To Previous Page
      </Link>
      <div className="card custom-card">
        <div className="card-body">
          <div>
            <h6 className="card-title mb-4">Record daily output</h6>
          </div>
          <form onSubmit={(e) => handleAddOutput(e)} method="post">
            <div className="row">
              <div className="mb-4 col-md-12">
                <label htmlFor="">
                  Team Name:<span className="tx-danger">*</span>
                </label>
                <Select
                  onChange={(e) => setTeamID(e.team_id)}
                  getOptionLabel={(option) => option.team_name}
                  getOptionValue={(option) => option.team_id}
                  isSearchable
                  options={Array.isArray(teamList) ? teamList : []}
                  value={
                    Array.isArray(teamList) &&
                    teamList.find((value) => value.team_id === teamId)
                  }
                />
              </div>
              <div className="mb-4 col-md-12">
                <label htmlFor="">
                  Achieved Work:<span className="tx-danger">*</span>
                </label>
                <input
                  type="text"
                  value={achievedWork}
                  onChange={(e) => setAchievedWork(e.target.value)}
                  className="form-control"
                />
              </div>
              <div className="mb-4 col-md-12">
                <label htmlFor="">
                  Site:<span className="tx-danger">*</span>
                </label>
                <input
                  type="text"
                  value={site}
                  onChange={(e) => setSite(e.target.value)}
                  className="form-control"
                />
              </div>
              <div className="mb-4 col-md-12">
                {loading && (
                  <button
                    disabled
                    style={{ width: "100%" }}
                    className="btn btn-success"
                  >
                    Submitting
                  </button>
                )}
                {!loading && (
                  <button style={{ width: "100%" }} className="btn btn-success">
                    Submit Output
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </AppContainer>
  );
}

export default CreateDailyOutput;
